import { Flex } from 'antd';
import { isEmpty } from 'lodash';
import { ReactNode } from 'react';

export interface PageProps {
  backgroundColor?: string;
  gap?: number;
  header?: ReactNode;
  children?: ReactNode;
}

const Page = ({ children, header, gap = 16, backgroundColor }: PageProps) => {
  return (
    <Flex vertical gap={gap} style={{ height: '100%', backgroundColor }}>
      {header}
      <Flex flex={1} vertical gap={12} style={{ overflow: 'auto' }}>
        {children}
      </Flex>
    </Flex>
  );
};

export default Page;
